import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'upmarket-product_details_page_sku-view';

/**
 * Event to track SKU views on the Product details page. The first parameter is a string that represents the SKU type (one of "single", "open-sizing", "prepack"). The second parameter is a string for the SKU itself.
 */
export function trackUpmarketProductDetailsPageSkuView(
  SKU_type: string,
  SKU2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { SKU_type, SKU2 },
  });
}
